import { BatchHttpLink } from '@apollo/client/link/batch-http'
import getConfig from 'next/config'
import { capitalize } from '~/utils/capitalize'
import { getFlow } from '~/components/FlowContext'

const { API_URL } = getConfig().publicRuntimeConfig
const { SECRET_INTERNAL_API_URL } = getConfig().serverRuntimeConfig
const isBrowser = typeof window !== 'undefined'
const APOLLO_URI = isBrowser ? API_URL : SECRET_INTERNAL_API_URL

const batchHttpLink = context => {
  const pageInfo = () => {
    if (isBrowser) return {}
    if (!context?.req) return {}

    const pathName = context.req.originalUrl
    const page = capitalize(pathName.split('?')[0].split('/')[1] || 'home').replace(/-/g, ' ')
    const path = encodeURIComponent(pathName)

    return { page, path }
  }
  const { page, path } = pageInfo()

  return new BatchHttpLink({
    uri: () => {
      const flow = getFlow(context?.flow)

      return isBrowser
        ? `${APOLLO_URI}/graphql/public/batch?flow=${flow}`
        : `${APOLLO_URI}/graphql/public/batch?page=${page}&path=${path}&flow=${flow}`
    },
    credentials: 'same-origin',
  })
}

export default batchHttpLink
